/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Field_CoverInputs */

const vi_media_field_cover = /** @type {(inputs: Media_Field_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh bìa`)
};

/**

* @param {Media_Field_CoverInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_field_cover = /** @type {((inputs?: Media_Field_CoverInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Field_CoverInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_field_cover(inputs)
});